import React from "react";
import { Col } from "react-bootstrap";

const FormField = ({ label, name, formik, type, colSize, placeholder, isTextarea, ...props }) => {
  return (
    <Col lg={colSize}>
      <div className="mb-3">
        <label htmlFor={name} className="form-label">{label}</label>
        
        {isTextarea ? (
          <textarea
            id={name}
            name={name}
            className="form-control"
            placeholder={placeholder}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values[name]}
            {...props}
          />
        ) : (
          <input
            type={type}
            id={name}
            name={name}
            className="form-control"
            placeholder={placeholder}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values[name]}
            {...props}
          />
        )}
        {formik.touched[name] && formik.errors[name] && (
          <div className="text-danger">{formik.errors[name]}</div>
        )}
      </div>
    </Col>
  );
};

export default FormField;
